import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
} from "@angular/core";
import { CanvasService } from "../../configurable/canvas/canvas-service.interface";

/**
 * Generated class for the ToolSelectorComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "tool-selector",
  templateUrl: "tool-selector.html",
})
export class ToolSelectorComponent implements AfterContentInit {
  @Input() tools: string[];
  existingData: object;
  @Input() painService: CanvasService;
  @ViewChild("buttonContainer") buttons;

  points;
  foundActive: boolean = false;
  currentTool: string;
  currentValues: object;
  currentSeverity: number;
  scrollRate: number = 25; // Percent of tool bar to scroll on click
  scrollAmount: number;
  subscriptions: Array<any> = [];

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    if (this.tools.length) {
      this.scrollRate = 100 / this.tools.length;
    }
    this.scrollAmount =
      this.buttons.nativeElement.scrollWidth * (this.scrollRate / 100);

    this.subscriptions.push(
      this.painService.getAllPointDataObservable().subscribe((data) => {
        if (!data || !data.points) {
          return;
        }

        this.points = data.points;
        // console.log("Points: ", this.points);
        this.foundActive = false;
        for (let i = 0; i < this.points.length; i++) {
          let point = this.points[i];
          // console.log( "Setting from point: ", point );

          if (!point.painTool && !point.unableToScore) {
            point.painTool = this.currentTool;
          }

          if (point.active) {
            // console.log( "Setting active: ", point.painTool, point.painValues);
            this.currentTool = point.painTool;

            if (point["unableToScore"]) {
              if (point["painValues"]) {
                for (let item in point["painValues"]) {
                  point["painValues"][item] = null;
                }
              }
            }

            this.existingData = {
              tool: this.currentTool,
              values: point.painValues,
              unableToScore: point["unableToScore"],
            };
            this.foundActive = true;
          }
        }
        if (!this.foundActive) {
          this.currentTool = "";
        }
      })
    );

    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions = [];
  }

  toolSelected(tool: string) {
    // console.log("Tool selected:", tool);
    this.currentTool = this.foundActive ? tool : "";
  }

  dataUpdate(data: object) {
    // console.log("Tool data update: ", data);

    this.currentValues = data["values"];
    this.currentSeverity = data["severity"];
    this.painService.updateActivePointData("painTool", this.currentTool);
    this.painService.updateActivePointData("painValues", this.currentValues);
    this.painService.updateActivePointData("severity", this.currentSeverity);
  }

  scrollLeft() {
    this.buttons.nativeElement.scrollLeft -= this.scrollAmount;
  }

  scrollRight() {
    this.buttons.nativeElement.scrollLeft += this.scrollAmount;
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/tool-selector/tool-selector.ts